export const CAMPAIGN_SETTINGS_SET = 'serviceData.CAMPAIGN_SETTINGS_SET';
export const CAMPAIGN_SETTINGS_SET_COMMIT = 'serviceData.CAMPAIGN_SETTINGS_SET_COMMIT';
